import * as basicLightbox from "basiclightbox";
import throttle from "lodash.throttle";
import gsap from "gsap/all";
import Disclaimer from 'DistributionPackages/Common/Bellevue.Disclaimer/Resources/Private/Fusion/Component/Disclaimer/Disclaimer';

export default () => ({
  modal: null,
  searchModal: null,
  searchModalVisibility: false,
  isOpen: false,
  hasScrolled: false,
  tweenProps: { duration: 0.15, force3D: false },

  init() {
    this.registerScrollEvent();
    this.registerSearchShortcutEvents();
    this.initMobileMenu();

    window.addEventListener("open-login-modal", () => {
      this.close();
      document.getElementById("menuToggleInput").checked = false;
    });

    this.initInvestorTypeMenu();
  },

  initMobileMenu() {
    this.modal = basicLightbox.create(
      document.querySelector(".mobile-navigation-menu"),
      {
        className: "basicLightbox--navigation",
        onShow: () => {
          this.isOpen = true;
          this._scrollPosition = window.pageYOffset;
          document
            .querySelector("header")
            .classList.toggle("pointer-events-none");
          document.body.classList.add("basicLightbox--enabled");
          document.body.style.top = `-${this._scrollPosition}px`;

          document.addEventListener("keydown", (event) => {
            if (event.key === "Escape") {
              this.close();
            }
          });
        },
        onClose: () => {
          this.isOpen = false;
          document
            .querySelector("header")
            .classList.remove("pointer-events-none");
          document.body.classList.remove("basicLightbox--enabled");
          document.body.style.top = null;
          window.scrollTo({
            top: this._scrollPosition,
            behavior: "instant",
          });
        },
      }
    );

    const navigationBreakpoint = window.matchMedia("(min-width: 1024px)");
    navigationBreakpoint.addListener(
      this.closeNavigationOnBreakpointChange.bind(this)
    );
  },

  toggle() {
    this.isOpen ? this.close() : this.open();
  },

  toggleSearchModal() {
    const searchModal = document.querySelector(".search");
    document.querySelector("body").classList.toggle("overflow-hidden");
    searchModal.classList.toggle("inactive-modal");

    if (searchModal.classList.contains("inactive-modal")) {
      document.querySelector(".search-input").focus();

      this.registerModalScrollEvent();
    }
  },

  closeSearchModal() {
    const searchModal = document.querySelector(".search");
    document.querySelector("body").classList.remove("overflow-hidden");
    searchModal.classList.remove("inactive-modal");
  },

  registerModalScrollEvent() {
    const modal = document.querySelector(".search");

    modal.addEventListener(
      "scroll",
      throttle((event) => {
        this.toggleTabBarShadow(event);
      }, 200)
    );
  },

  toggleTabBarShadow(event) {
    const scrollContainer = event.target;
    const tabBar = document.querySelector(".search .tab-bar");

    if (scrollContainer.scrollTop > 200) {
      return tabBar.classList.add("shadow");
    }

    return tabBar.classList.remove("shadow");
  },

  open() {
    this.modal.show();

    this.scaleLogoDown();
  },

  close() {
    this.modal.close();
  },

  closeNavigationOnBreakpointChange(x) {
    if (x.matches && this.isOpen) {
      this.close();
    }
  },

  registerScrollEvent() {
    document.addEventListener(
      "scroll",
      throttle(() => {
        this.scrollHandler();
      }, 200)
    );
  },

  registerSearchShortcutEvents() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode === 75 && e.metaKey) {
        this.toggleSearchModal();
      }

      if (e.keyCode === 27) {
        this.closeSearchModal();
      }
    });
  },

  scrollHandler() {
    // prevent scroll handling when mobile nav is open
    if (this.isOpen) return;

    const logo = document.querySelector(".meta-nav .logo svg");

    this.hasScrolled = window.scrollY >= 10;

    if (this.hasScrolled) {
      return gsap.to(logo, {
        scale: 0.8,
        y: -45,
        transformOrigin: "left center",
        ...this.tweenProps,
      });
    }

    // scale logo to default size
    this.scaleLogoUp();
  },

  scaleLogoDown() {
    const logo = document.querySelector(".meta-nav .logo svg");

    gsap.to(logo, {
      scale: 0.8,
      y: -45,
      transformOrigin: "left center",
      ...this.tweenProps,
    });
  },

  scaleLogoUp() {
    const logo = document.querySelector(".meta-nav .logo svg");

    gsap.to(logo, {
      scale: 1,
      y: 0,
      ...this.tweenProps,
    });
  },

  initInvestorTypeMenu() {
    window.addEventListener('investorTarget', () => {
      this.close();
      document.getElementById('menuToggleInput').checked = false;
      window.disclaimer = window.disclaimer || new Disclaimer();
      window.disclaimer.showDisclaimer();
    })
  },
});
